import React from "react"
import ReactTooltip from "react-tooltip"

import "./additive-tooltip.sass"

class AdditiveTooltip extends React.Component {
  componentDidUpdate() {
    ReactTooltip.rebuild()
  }

  render() {
    return (
      <ReactTooltip
        effect={"solid"}
        html={true}
        multiline={true}
        insecure={true}
        place={"right"}
        className={"_fp-additive-tooltip"}
      />
    )
  }
}

export default AdditiveTooltip
